import { SparkResultKind } from '../types/sparkTypes';

interface ResultHandoffOptions {
  resultKind?: SparkResultKind | null;
  outputTypeName?: string;
  currentTypeName?: string;
  isCurrentStep?: boolean;
  includeActivityHint?: boolean;
}

function formatInlineTypeName(typeName?: string): string {
  return typeName?.trim().toLowerCase() || 'item';
}

export function getResultHandoffText({
  resultKind,
  outputTypeName,
  currentTypeName,
  isCurrentStep = false,
  includeActivityHint = true,
}: ResultHandoffOptions): string | null {
  const activityHint = includeActivityHint ? ' Track progress in Activity.' : '';
  const inlineTypeName = formatInlineTypeName(currentTypeName);

  switch (resultKind) {
    case 'media':
      return null;
    case 'creation':
      if (isCurrentStep) {
        return `Results will appear on this board when ready.${activityHint}`;
      }
      if (outputTypeName) {
        return `Results will appear on the ${outputTypeName} board when ready.${activityHint}`;
      }
      return `Results will appear on the target board when ready.${activityHint}`;
    case 'iteration':
      return `A new version of this ${inlineTypeName} will appear when ready.${activityHint}`;
    case 'evaluation':
      return `Feedback will appear in the chat for this ${inlineTypeName} when ready.${activityHint}`;
    default:
      return null;
  }
}
